import type { ReactNode } from "react";

import clsx from "clsx";
import { Cell as AriaCell } from "react-aria-components";

import { Skeleton } from "../../skeleton";

import styles from "./table-cell.module.css";

type TableCellProps = {
	children: ReactNode;
	className?: string;
	isLoading: boolean;
	minWidth?: number | string;
	width?: number | string;
};
export function TableCell({ children, className, isLoading, minWidth, width }: TableCellProps) {
	return (
		<AriaCell
			className={clsx(className, styles.cell)}
			style={{ minWidth: minWidth, width: width }}
		>
			{isLoading ? <Skeleton height={12} width={minWidth ?? 100} /> : children}
		</AriaCell>
	);
}
